import { BreakpointState } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { map, Observable } from "rxjs";

import { TagComponent } from "@hermes/aphrodite/tag";
import { GridProduct } from "@hermes/states/grid-filters-state";
import { BreakpointService } from "@hermes/utils-generic/services/user-interface";

@Component({
    standalone: true,
    imports: [TagComponent, CommonModule],
    selector: "h-out-of-stock-label",
    templateUrl: "./out-of-stock-label.component.html",
    styleUrls: ["./out-of-stock-label.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutOfStockLabelComponent {
    @Input() public product!: GridProduct;

    public isMobile$: Observable<boolean>;

    constructor(public breakpointService: BreakpointService) {
        this.isMobile$ = this.breakpointService
            .mediumBreakpointObserver()
            .pipe(map((value: BreakpointState) => !value.matches));
    }
}
